import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { RelocationSandbox } from 'app/core/sandboxes/relocation.sandbox';
import { SessionState } from 'app/core/store/session/session.interface';
import { fadeInAnimation } from 'app/animations';
import * as fromRoot from 'app/core/store';
import { Florder } from 'app/core/interfaces/florder.interface';
import { Florders } from 'app/core/interfaces/florders.interface';
import * as relocationsActions from 'app/core/store/relocations/relocations.actions';
import { UserContext } from 'app/core/store/session/user-context/user-context.interface';
import { util } from 'app/core/util/util';
import { FlorderPageContainer } from 'app/modules/florders/florder-page-container/florder-page.container';
import { goAction } from 'app/core/store/router/router.actions';
import { takeWhile } from 'rxjs/operators';

@Component({
  selector: 'app-relocation-page',
  templateUrl: './relocation-page.container.html',
  styleUrls: ['../../florders/florder-page-container/florder-page.container.scss'],
  animations: [fadeInAnimation],
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RelocationPageContainer extends FlorderPageContainer {
  relocations: Florders;
  userContext: UserContext;

  constructor(private sandbox: RelocationSandbox) {
    super();
    this.store
      .select('relocations')
      .pipe(takeWhile(() => !this.destroyed))
      .subscribe((relocations: Florders) => {
        this.relocations = relocations;
        this.filter = util.deepCopy(relocations.filter); // We will change this object
        this.totalItems = relocations.totalItems;
        this.ordersAreLoading = relocations.loading;
      });
    this.store
      .select('session')
      .pipe(takeWhile(() => !this.destroyed))
      .subscribe((session: SessionState) => {
        this.userContext = session.userContext;
      });
  }

  protected reload(): void {
    this.store.dispatch(new relocationsActions.RelocationsLoadAction({ filter: this.filter }));
  }

  createFlorder(): void {
    if (this.userContext.canRelocate) {
      this.store.dispatch(
        goAction({
          path: ['relocation/new'],
          query: { back: 'relocations' },
        })
      );
    }
  }

  copyRelocation(relocation: Florder): void {
    this.sandbox.copyRelocation(relocation.etmOrderNumber);
  }

  asTemplate(relocation: Florder): void {
    this.sandbox.createTemplateFromRelocation(relocation);
  }

  createTemplate(): void {
    if (this.userContext.canRelocate) {
      this.sandbox.createTemplate();
    }
  }

  openRelocation(florder: Florder): void {
    if (this.userContext.canRelocate) {
      this.store.dispatch(
        goAction({
          path: [`relocation/${florder.etmOrderNumber}`],
          query: { salesOrderNumber: florder.salesOrderNumber, back: 'relocations' },
        })
      );
    }
  }

  gotoCalendar() {
    this.store.dispatch(goAction({ path: '/calendar/relocation' }));
  }

  resetFilter() {
    this.sandbox.resetFilter();
  }

}
